import classNames from "classnames";
import React from "react";
import { Controller } from "react-hook-form";
import get from "lodash.get"; 
export default function TextArea({
  name,
  placeholder,
  control,
  errors,
  rules,
  disabled,
  labelClassName,
  className,
  label,
  rows,
  leftIcon,
  rightIcon,
  onChange: customOnChange,
}) {

   const errorMessage = get(errors, name)?.message; 
  return (
    <div className="w-full relative">
      <Controller
        render={({ field: { onChange, value, onBlur } }) => (
          <>
            {label && (
              <label
                className={classNames(
                  "mb-2.5 block text-navy  text-sm font-helvetica font-semibold",
                  labelClassName
                )}
              >
                {label}
              </label>
            )}
            {leftIcon && (
              <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                {leftIcon}
              </div>
            )}
            <textarea
            
              className={classNames(
                "w-full  appearance-none rounded-lg placeholder-placeholderColor border text-sm text-black  border-borderColor bg-white py-2 pl-4 pr-10 outline-none font-helvetica focus:border-primary focus-visible:shadow-none",
                className
              )}
              spellCheck={false}
              aria-invalid={errors && errorMessage ? "true" : "false"}
              aria-describedby={`${name}Error`}
              placeholder={placeholder}
              onChange={(e) => {
                onChange(e);
                if (customOnChange) {
                  customOnChange(e);
                }
              }}
              onBlur={onBlur}
              value={value || ""}
              disabled={disabled}
              autoComplete="off"
              aria-autocomplete="none"
              rows={rows}
            />
            {rightIcon && (
              <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                {rightIcon}
              </div>
            )}
          </>
        )}
        name={name}
        control={control}
        rules={rules}
      />

      {errorMessage && (
        <p className="text-[#f00] text-[12px]">
          <span role="alert" id={`${name}Error`}>
            {errorMessage}
          </span>
        </p>
      )}
    </div>
  );
}
